import { useCallback } from "react";

export function useScrollItemIntoCenter(listRef) {
  const scrollItemIntoCenter = useCallback(
    (element) => {
      if (!listRef.current || !element) return;

      const parent = listRef.current;
      const parentRect = parent.getBoundingClientRect();
      const elementRect = element.getBoundingClientRect();

      const offset =
        elementRect.left -
        parentRect.left -
        parent.clientWidth / 2 +
        elementRect.width / 2;

      if (typeof parent.scrollBy === "function") {
        parent.scrollBy({ left: offset, behavior: "smooth" });

        return;
      }

      if (typeof parent.scrollTo === "function") {
        parent.scrollTo({ left: (parent.scrollLeft || 0) + offset });

        return;
      }

      parent.scrollLeft = (parent.scrollLeft || 0) + offset;
    },
    [listRef],
  );

  return scrollItemIntoCenter;
}
